import React from 'react';
import PropTypes from 'prop-types';

export default function BlockWithCheckbox({
  title, description, className, checkboxValue, checked, onChange, showCheckbox,
}) {
  return (
    <div className={className}>
      <label htmlFor={checkboxValue} className={`topic h-100 ${checked ? 'checked' : ''}`}>
        <div className="d-flex mb-1">
          <div className="flex-grow-1 text-truncate">{title}</div>
          {showCheckbox && (
          <div className="ms-auto">
            <label htmlFor={checkboxValue}>
              <input
                onChange={() => onChange(checkboxValue)}
                id={checkboxValue}
                className="boolean optional form-check-input"
                type="checkbox"
                checked={checked}
              />
            </label>
          </div>
          )}
        </div>
        <p>{description}</p>
      </label>
    </div>
  );
}

BlockWithCheckbox.propTypes = {
  title: PropTypes.string,
  description: PropTypes.element,
  className: PropTypes.string,
  checkboxValue: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  showCheckbox: PropTypes.bool,
};

BlockWithCheckbox.defaultProps = {
  title: '',
  description: null,
  className: '',
  checked: false,
  onChange: () => {},
  showCheckbox: true,
};
